/**
 * GemGrace — light GSAP micro-animations (header, footer promo bar, footer, optional main sections).
 * Respects prefers-reduced-motion. Skips sections that already use CSS .scroll-trigger.
 */
(function () {
  if (typeof gsap === 'undefined') return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const easeOut = 'power2.out';
  const easeSoft = 'power3.out';

  function runHeader() {
    const root = document.querySelector('[data-gsap-header]');
    if (!root || root.dataset.gsapHeaderInit === '1') return;
    const header = root.querySelector('.header');
    if (!header || !header.children.length) return;
    root.dataset.gsapHeaderInit = '1';
    gsap.from(header.children, {
      autoAlpha: 0,
      y: -14,
      duration: 0.48,
      stagger: 0.05,
      ease: easeOut,
      clearProps: 'transform',
    });
  }

  function runFooterBar() {
    const bar = document.querySelector('[data-gsap-footer-bar]');
    if (!bar || bar.dataset.gsapFooterBarObserved === '1') return;

    const inner = bar.querySelector('.footer-top-bar');
    const targets = inner ? inner.children : [bar];
    gsap.set(targets, { autoAlpha: 0, y: 18 });

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          gsap.to(targets, {
            autoAlpha: 1,
            y: 0,
            duration: 0.52,
            stagger: 0.08,
            ease: easeSoft,
            clearProps: 'transform',
          });
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );
    bar.dataset.gsapFooterBarObserved = '1';
    io.observe(bar);
  }

  function runFooter() {
    const footer = document.querySelector('[data-gsap-footer]');
    if (!footer || footer.dataset.gsapFooterObserved === '1') return;

    const blocks = footer.querySelectorAll('.footer-block');
    const newsletter = footer.querySelector('.footer-block--newsletter');
    const bottom = footer.querySelector('.footer__content-bottom');
    const toPrep = [...blocks, newsletter, bottom].filter(Boolean);
    if (!toPrep.length) return;

    gsap.set(toPrep, { autoAlpha: 0, y: 22 });

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          const tl = gsap.timeline({ defaults: { ease: easeOut } });
          if (blocks.length) {
            tl.to(blocks, { autoAlpha: 1, y: 0, duration: 0.48, stagger: 0.065 }, 0);
          }
          if (newsletter) {
            tl.to(newsletter, { autoAlpha: 1, y: 0, duration: 0.45 }, blocks.length ? 0.1 : 0);
          }
          if (bottom) {
            tl.to(bottom, { autoAlpha: 1, y: 0, duration: 0.4 }, '>-0.12');
          }
          tl.eventCallback('onComplete', () => {
            gsap.set(toPrep, { clearProps: 'transform' });
          });
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    footer.dataset.gsapFooterObserved = '1';
    io.observe(footer);
  }

  function shouldSkipMainSection(section) {
    if (section.querySelector('.scroll-trigger')) return true;
    if (section.querySelector('slideshow-component')) return true;
    if (section.querySelector('.image-banner')) return true;
    if (section.querySelector('.collection-hero')) return true;
    if (section.id && section.id.indexOf('shopify-section-header') !== -1) return true;
    if (section.id && section.id.indexOf('shopify-section-footer') !== -1) return true;
    return false;
  }

  function runMainSections() {
    const main = document.getElementById('MainContent');
    if (!main) return;

    const sections = main.querySelectorAll('.shopify-section');
    if (!sections.length) return;

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          obs.unobserve(el);
          gsap.fromTo(
            el,
            { autoAlpha: 0, y: 26 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.52,
              ease: easeOut,
              clearProps: 'transform',
            }
          );
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
    );

    sections.forEach((section) => {
      if (shouldSkipMainSection(section)) return;
      if (section.dataset.gsapSectionInit === '1') return;
      section.dataset.gsapSectionInit = '1';
      gsap.set(section, { autoAlpha: 0, y: 26 });
      io.observe(section);
    });
  }

  function init() {
    runHeader();
    runFooterBar();
    runFooter();
    runMainSections();
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!target || !target.classList || !target.classList.contains('shopify-section')) return;
    if (target.querySelector('[data-gsap-header]')) {
      delete target.querySelector('[data-gsap-header]').dataset.gsapHeaderInit;
      runHeader();
    }
    if (target.querySelector('[data-gsap-footer]')) {
      const f = target.querySelector('[data-gsap-footer]');
      delete f.dataset.gsapFooterObserved;
      runFooter();
    }
    if (target.querySelector('[data-gsap-footer-bar]')) {
      const b = target.querySelector('[data-gsap-footer-bar]');
      delete b.dataset.gsapFooterBarObserved;
      runFooterBar();
    }
    runMainSections();
  });
})();
